import type { PosDatabase } from '@core/db/db'
import { META_ACTIVE_SHIFT_ID, META_STORE_ID } from '@core/db/schema'

/** Контекст активной смены для облачного Z по зоне. */
export interface ActiveShiftContext {
  zoneId?: string
  storeId?: string
  shiftNumber?: number
}

/**
 * Зона и номер активной смены этой кассы.
 *
 * Единая точка для всех документов (продажи, коррекции, возвраты): без
 * zone_id/shift_number чек не попадёт в облачный Z по зоне (ARCH-TASK-65.6).
 */
export async function getActiveShiftContext(
  db: Pick<PosDatabase, 'meta' | 'shifts'>
): Promise<ActiveShiftContext> {
  const storeEntry = await db.meta.get(META_STORE_ID)
  const storeId =
    storeEntry && typeof storeEntry.value === 'string' ? storeEntry.value : undefined
  const entry = await db.meta.get(META_ACTIVE_SHIFT_ID)
  const numericId = typeof entry?.value === 'number' ? entry.value : Number(entry?.value)
  if (Number.isFinite(numericId)) {
    const shift = await db.shifts.get(numericId)
    if (shift) return { zoneId: shift.zoneId, storeId: shift.storeId ?? storeId, shiftNumber: shift.shiftNumber }
  }
  const open = await db.shifts.where('status').equals('open').first()
  return open
    ? { zoneId: open.zoneId, storeId: open.storeId ?? storeId, shiftNumber: open.shiftNumber }
    : { storeId }
}
